<template>
    <div
        :id="id"
        class="input-select-wrapper"
    >
        <div
            class="input-select"
            :class="{ error: isError, disabled }"
        >
            <template
                v-for="item in items"
                :key="item.itemId"
            >
                <Tooltip
                    v-if="item.tooltip?.value"
                    :tip="item.tooltip?.value"
                    :placement="item.tooltip?.placement"
                >
                    <div
                        class="input-select-item"
                        :class="{ active: item.value === modelValue, disabled }"
                        data-testid="input-radio-item"
                        @click="selectItem(item)"
                    >
                        <Words small>
                            {{ itemLabel ? itemLabel(item) : item.label }}
                        </Words>
                    </div>
                </Tooltip>
                <div
                    v-else
                    class="input-select-item"
                    :class="{ active: item.value === modelValue, disabled }"
                    data-testid="input-radio-item"
                    @click="selectItem(item)"
                >
                    <Words small>
                        {{ itemLabel ? itemLabel(item) : item.label }}
                    </Words>
                </div>
            </template>
        </div>
        <ErrorText
            v-if="error"
            :error="error"
            clip
        />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import ErrorText from 'widget-components/components/ErrorText'
import Words from 'widget-components/components/Words'
import Tooltip from 'widget-components/atoms/Tooltip/Tooltip.vue'
import type { BlockPath, CPTooltip } from 'widget-components/integrations/CustomPage/types'

defineOptions({ inheritAttrs: false })

type InputRadioItem = {
    itemId?: string
    label?: string
    value?: string
    tooltip?: CPTooltip
    selectedItemId?: string
}

const props = defineProps<{
    id?: string
    items?: InputRadioItem[]
    modelValue?: string
    initialValue?: string
    itemLabel?: (i: InputRadioItem) => string
    itemValue?: (i: InputRadioItem) => string
    error?: string
    disabled?: boolean
    blockPath?: BlockPath
    selectedItemId?: string
}>()

const emit = defineEmits(['update:modelValue'])

onMounted(async () => {
    const preselectedItem = props.items?.find(i => i.itemId === props.selectedItemId)

    if (preselectedItem?.itemId) {
        // This is a hack for ListView, without it we can't see the default value, because selectItem fires too fast
        setTimeout(() => {
            selectItem(preselectedItem)
        }, 0)
    }
})

const isError = computed(() => !!props.error)

const selectItem = (item: InputRadioItem) => {
    if (props.disabled) {
        return
    }
    if (props.itemValue) {
        emit('update:modelValue', props.itemValue(item))
    } else {
        emit('update:modelValue', item.value)
    }
}
</script>

<style lang="sass" scoped>
@import './InputRadio.sass'
</style>
